module.exports = __webpack_public_path__ + "media/assets/images/flags/kr-493b883a256d50a923347f31e4b505ff.svg";